import Cookies from 'js-cookie'

// 顶级域名
const DO_MAIN = 'cabplink.com'
// 登录标识
const CONSUMER_CONDITION_KEY = 'us-key'
// 机构标识
const ORGANISED_MARK = 'organised_mark'

const CONSUMER_IDENTITY_KEY = 'CONSUMER_IDENTITY'
//详情页目录进入阅读器自带id
const FROM_CATALOGID = 'from_catalogid'

/** 登录状态 */
export function getUserToken () {
  return Cookies.get(CONSUMER_CONDITION_KEY)
}
export function setUserToken (token) {
  return Cookies.set(CONSUMER_CONDITION_KEY, token, {domain: DO_MAIN})
}
export function removeUserToken () {
  return Cookies.remove(CONSUMER_CONDITION_KEY, {domain: DO_MAIN})
}

export function setToken (token, expiresVal) {
  return expiresVal ? Cookies.set(CONSUMER_CONDITION_KEY, token, {expires: 7, domain: DO_MAIN}) : Cookies.set(CONSUMER_CONDITION_KEY, token, {domain: DO_MAIN})
}

/** 机构标识 */
export function getOrganisedMark () {
  return Cookies.get(ORGANISED_MARK)
}
export function setOrganisedMark () {
  Cookies.set(ORGANISED_MARK, 'organised', {domain: DO_MAIN})
}
export function removeOrganisedMark () {
  return Cookies.remove(ORGANISED_MARK, {domain: DO_MAIN})
}

/** 来自详情页目录 */
export function getFromCatalogid () {
  return Cookies.get(FROM_CATALOGID)
}
export function setFromCatalogid (id) {
  return Cookies.set(FROM_CATALOGID, id, {expires: 7, domain: DO_MAIN})
}
export function removeFromCatalogid () {
  return Cookies.remove(FROM_CATALOGID, {domain: DO_MAIN})
}


// WEBPACK FOOTER //
// ./src/utils/cookies.js